import React, {useState} from 'react';
import PropTypes from 'prop-types';
import Popup from "../../../../../components/WMS/Mobile/Popup";
import { ReactComponent as EmptyBox } from "assets/img/wms/emptyBox.svg";
import {Grid} from "@mui/material";
import CustomButton from "../../../../../components/CustomButton";
import {FormattedMessage} from "react-intl";
import {assignShipmentToContainer} from "../../../../../api/wms/shipment/shipment";

OffChartModal.propTypes = {
    open: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
    selectedContainer: PropTypes.object.isRequired,
    shipment: PropTypes.object.isRequired,
    finishPacking: PropTypes.func.isRequired
};

function OffChartModal({open, handleClose, selectedContainer, shipment, finishPacking}) {
    const handleValid = () => {
        assignShipmentToContainer(selectedContainer.codebar, shipment.shipmentId).then(() => {
            finishPacking()
        })
    }
    return (
        <Popup
            open={open}
            onClose={handleClose}
            title={<FormattedMessage id={"wms.packing.modal.offChartDrop.title"}/>}
            subtitle={<FormattedMessage id={"wms.packing.modal.offChartDrop.subtitle"}/>}
            icon={<EmptyBox/>}
        >
            <Grid container direction={"column"} gap={"16px"}>
                <CustomButton fullWidth color={"default"} onClick={handleValid}>
                    <FormattedMessage id={"wms.packing.modal.offChartDrop.validButton"}/>
                </CustomButton>
                <CustomButton fullWidth onClick={handleClose}>
                    <FormattedMessage id={"wms.packing.modal.offChartDrop.cancelButton"}/>
                </CustomButton>
            </Grid>
        </Popup>
    );
}

export default OffChartModal;